<script setup>
import {computed, ref, onMounted, nextTick} from 'vue'
import {useUserStore} from '@/stores/user'

const props = defineProps({
    field: Object,
    currentData: Object,
})

// Pinia Store
const userStore = useUserStore()

// Template refs and reactive data
const codeMirror = ref(null)
const value = ref('')

// Computed properties
const prefs = computed(() => userStore.pref('codeMirror'))

// Lifecycle hooks
onMounted(() => {
    const indent = 2
    const rawData = props.currentData?.[props.field?.name]

    // Strictly check for object and non-null
    if (rawData !== null && typeof rawData === 'object') {
        value.value = JSON.stringify(rawData, null, indent)
    } else {
        value.value = rawData ?? ''
    }

    const options = {
        mode: 'application/json',
        lineNumbers: true,
        lineWrapping: true,
        readOnly: true,
        indentUnit: indent,
        tabMode: 'spaces',
        enterMode: 'indent',
        electricChars: false
    }

    if (prefs.value?.theme) {
        options.theme = prefs.value.theme
    }

    nextTick(() => {
        if (typeof CodeMirror !== 'undefined' && codeMirror.value) {
            // Set textarea value directly before initializing CodeMirror
            // to ensure it reads the stringified text, not the initial DOM state.
            codeMirror.value.value = value.value
            CodeMirror.fromTextArea(codeMirror.value, options)
        }
    })
})
</script>

<template>
    <textarea ref="codeMirror" :value="value"></textarea>
</template>